import Vue from 'vue';

Vue.filter('formattedWall', function(value) {
    if(!value) return;
    if (value.indexOf('padres') === -1) {
        return value.replace(/-/g, ' ').replace(value[0], value[0].toUpperCase());
    } else {
        let result = [];
        let arr = value.replace(/-/g, ' ').split(' ');
        arr.forEach(s => {
            result.push(s.replace(s[0], s[0].toUpperCase()));
        });
        return result.join(' ');
    }
});